module.exports = __webpack_public_path__ + "media/images/cloud-cma-emblem-89f471c4486ef25eee94eed2df08da40.svg";